import classNames from 'classnames';
import React from 'react';
import styles from './container.module.scss';

export interface ContainerProps {
  children?: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  /** Applies a theme through the global `.hasTheme[data-theme]` rule */
  theme?: Theme;
}

const Container = ({
  children,
  className,
  fullWidth = false,
  theme,
}: ContainerProps) => {
  return (
    <div
      className={classNames(styles.component, className, {
        hasTheme: theme,
        [styles.isFullWidth]: fullWidth,
      })}
      data-theme={theme ?? undefined}
    >
      {children}
    </div>
  );
};

export default Container;
